import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=0c37fade&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=0c37fade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c37fade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c37fade')) {
      api.createRecord('0c37fade', component.options)
    } else {
      api.reload('0c37fade', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=0c37fade&scoped=true&", function () {
      api.rerender('0c37fade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KrC0rzdYyKR7/JS/comp/DocBox.vue"
export default component.exports